import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

//get wallet overview


//get funding history for all balances, including from subwallets.
export function getWalletOverview(){
  const url = `${BASE_URL}/overview/wallet`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
  })

}

//get funding history for all balances, including from subwallets.
export function getAllWalletsFundingHistory(perPage = 10, page = 1, para = {}, download = 0){
  const url = `${BASE_URL}/wallets/history`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
      para: para,
      download: download,
    },
  })

}


//get a particular merchant wallets, type signifies either primary or secondary.
export function getWallets(perPage = 10, page = 1, wallet_type, para = {}){
  const url = `${BASE_URL}/wallets`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
      type: wallet_type,
      para: para
    },
  })

}

export function getWalletById(id){
  const url = `${BASE_URL}/wallets/` + id;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');

  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    }
  })

}

//get  funding history for a single wallet balance.
export function getWalletFundingHistory(walletId, perPage = 10, page = 1, para = {}, download = 0){
  const url = `${BASE_URL}/wallets/` + walletId + `/history`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
      para: para,
      download: download,
    }
    // paramsSerializer: filter => Qs.stringify(filter, {arrayFormat: 'bracket'})
  })

}

//create new wallet
export function createWallet(walletname,walletPassword,walletCurrency,walletUref,countryTag){
  const url = `${BASE_URL}/wallets/`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      name:walletname,
      password: walletPassword,
      currency: walletCurrency,
      uref: walletUref,
      countryTag
    },
  })

}

//transfer to another wallet
export function walletTransfer(dataObj){
  const url = `${BASE_URL}/wallets/walletDisburse`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      sourceWallet: dataObj.sourceUref, // uref of the wallet money is coming from
      recipientWallet: dataObj.destUref, // uref of the wallet money is going to 
      lock: dataObj.wallet.password,
      amount: dataObj.amount,
      currency: dataObj.wallet.currency,
      // ref: dataObj.reference,
      recipientId: merchantId,
      narration: dataObj.narration,
    },
  })

}

//Change wallet Password
export function changeWalletPassword(data){
  const url = `${BASE_URL}/wallets/${data.id}/change`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      email:data.email,
      id: data.id,
      lockCode: data.lockCode,
      newLockCode: data.newLockCode,
    },
  })

}

//Change wallet Password
export function forgotWalletPassword(data){
  const url = `${BASE_URL}/wallets/${data.id}/forgot`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      email:data.email,
      id: data.id,
    },
  })

}

export function linkACard(dataObj){
  const url = `${BASE_URL}/wallets/link/card`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      card_no:dataObj.card_no,
      cvv: dataObj.cvv,
      expiry_year: dataObj.expiry_year,
      expiry_month: dataObj.expiry_month
    },
  })

}

export function deleteCard(dataId){
  const url = `${BASE_URL}/wallets/link/card`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      id:dataId,
    },
  })

}

//get wallet transactions
export function getWalletTransactions(walletId, perPage = 10, page = 1, type, disbOrFund, para = {}, download){
  const url = `${BASE_URL}/wallets/` + walletId + `/transactions`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  let systemType = type;
  let disburseOrFunding = disbOrFund;
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId,
      'system_type': systemType,
      'dbOrFu': disburseOrFunding
    },
    params:{
      per_page:perPage,
      page:page,
      para: para,
      download,
    },
  })
}



// WEBPACK FOOTER //
// ./src/utils/wallet-transactions/walletService.js